import { Page } from '../../../../components/Page/Page';
import { TimetableSubjectsTable } from '../../../../components/Subjects/Tables/TimetableSubjectsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const TimetableSubjectsSubpage = () => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()}>
      <TimetableSubjectsTable />
    </Page>
  );
};
